<script setup>
import { storeToRefs } from 'pinia'

import { useModalStore } from '@/stores/modal'

const modalStore = useModalStore()
const { modals } = storeToRefs(modalStore)

function closeModal(id) {
  modalStore.closeModal(id)
}
</script>

<template>
  <component
    :is="modal.component"
    v-for="modal in modals"
    :key="modal.id"
    v-bind="modal.props"
    @close="closeModal(modal.id)"
  />
</template>
